// App.tsx
import React, { useState, useEffect, Suspense, lazy } from 'react';
import { PermissionsProvider } from './context/PermissionsContext';
import Auth from './utils/auth'
import config from './config/config';
import InitialOverlay from './components/common/InitialOverlay';
import { BrowserRouter as Router, Route, Routes, Navigate, Outlet } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import AppWrapperComponent from './pages/AppWrapperComponent';
import AppWrapperViewComponent from './pages/AppWrapperViewComponent';
import RegistrationForm from './components/Auth/RegistrationForm';
import GlobalRenderController from './components/common/GlobalRenderController';
import { AuthErrorModal } from './auth/AuthErrorModal';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './pages/DashboardPOC/DashboardPOC.css';
import './pages/Auth/AuthWrapper.css';
import './pages/UserList/UserList.css';
import './pages/LandingPage/LandingPage.css';
import './pages/HomePage/HomePage.css';
import './pages/Report/Report.css';
import './pages/EmbeddedMapsPOC/EmbeddedMapsPOC.css';
import './pages/CommonLoginPage/commonlogin.css';
import './pages/WebSitePageNew/WebSitePage.css';
import './pages/Report/health-report.css';
import './pages/Report/Report Tabs/ParameterSelection/ReportFilter/ReportExport/ReportExport.css';
import './pages/Report/ReportPopup/Popup.css';
import "./pages/Beneficiary-block/BeneficiaryWrapper/BeneficiaryWrapper.css";
import './pages/Beneficiary-block/WomenComponent/ANC/Forms/View/index.css';
import "./pages/Beneficiary-block/WomenComponent/Death/DeathForm/DeathForm.css";
import './pages/Beneficiary-block/WomenComponent/PregnancyTracking/index.css';
import './pages/Beneficiary-block/WomenComponent/FamilyPlanning/view/index.css';
import './pages/Beneficiary-block/WomenComponent/FacilityReferral/FacilityReferral.css';
import './pages/Beneficiary-block/WomenComponent/FacilityReferral/ReferralView/ReferralView.css';
import "./pages/Beneficiary-block/WomenComponent/FacilityReferral/Grid/index.css";
import './pages/CommonLoginPage/FirstLoginPage/CommonloginPage.css';

//import Dashboard from './pages/Dashboard';
const DashboardPOC = lazy(() => import('./pages/DashboardPOC'));
//import LogoutPage from './pages/Auth/LogoutPage';
const LogoutPage = lazy(() => import('./pages/Auth/LogoutPage'));
//import UserList from './pages/UserList';
const UserList = lazy(() => import('./pages/UserList'));
//import user self registration component
const UserSelfRegistration = lazy(() => import('./pages/SelfRegistration/User/index'));
//import beneficiary self registration component
const BeneficiarySelfRegistartion = lazy(() => import('./pages/SelfRegistration/Beneficiary/index'));
//import LandingPageWrapperComponent from './pages/LandingPage';
const LandingPageWrapperComponent = lazy(() => import('./pages/LandingPage'));
const ServiceMasterWrapperComponent = lazy(() => import('./pages/ServiceMaster'));
import LocalizationApp from './components/LocalizationApp';
// const LocalizationApp = lazy(() => import('./components/LocalizationApp'));
//import HomePage from './pages/HomePage';
const HomePage = lazy(() => import('./pages/HomePage'));
//import Report from './pages/Report';
const Report = lazy(() => import('./pages/Report'));
//import Graphqlpoc from './pages/Graphqlpoc';
const Graphqlpoc = lazy(() => import('./pages/Graphqlpoc'));
import PlatformComponent from './components/PlatformComponent';
import { PagePermissionRedirect } from './components/Auth/pagePermissionRedirect';
//import EmbeddedMapsPOC from './pages/EmbeddedMapsPOC';
const EmbeddedMapsPOC = lazy(() => import('./pages/EmbeddedMapsPOC'));
//import ReportExport from './pages/Report/Report Tabs/ParameterSelection/ReportFilter/ReportExport';
const ReportExport = lazy(() => import('./pages/Report/Report Tabs/ParameterSelection/ReportFilter/ReportExport'));
//import Commonlogin from './pages/CommonLoginPage';
const Commonlogin = lazy(() => import('./pages/CommonLoginPage'));
import { WebsiteProvider } from './context/WesiteContext';
//import WebSitePageNew from './pages/WebSitePageNew';
const WebSitePageNew = lazy(() => import('./pages/WebSitePageNew'));
//import AuthWrapperComponent from '@pages/Auth/AuthWrapperComponent';
const AuthWrapperComponent = lazy(() => import('@pages/Auth/AuthWrapperComponent'));
import InactivityDetector from '@components/Auth/InactivityDetector';
const BenefLandingPage = lazy(() => import('./pages/BenefLandingPage'));
import { decodeWithKeyAndShift } from './utils/base64Utils';
//import HealthFacilityMasterReport from '@pages/Report/HealthFacilityMasterReport';
const HealthFacilityMasterReport = lazy(() => import('@pages/Report/HealthFacilityMasterReport'));
//import HealthProviderMasterReport from '@pages/Report/HealthProviderMasterReport';
const HealthProviderMasterReport = lazy(() => import('@pages/Report/HealthProviderMasterReport'));
const PregnantWomenReport = lazy(() => import('@pages/Report/PregnantWomenReport'));
const PwLineListingReport = lazy(() => import('@pages/Report/PwLineListingReport'));
const TestsDoneReport = lazy(() => import('@pages/Report/TestsDoneReport'));
const PregnancyCareServicesReport = lazy(() => import('@pages/Report/PregnancyCareServicesReport'));
const DeliveryReport = lazy(() => import('@pages/Report/DeliveryReport'));
const ANCReport = lazy(() => import('@pages/Report/ANCReport'));
const HIVPWsSyphilisReport = lazy(() => import('@pages/Report/HIVPWsSyphilisReport'));
//import ReportPage2 from '@pages/Report/Report Tabs/ParameterSelection/ReportFilter/ReportExport/ReportPage2';
const ReportPage2 = lazy(() => import('@pages/Report/Report Tabs/ParameterSelection/ReportFilter/ReportExport/ReportPage2'));
//import BeneficiaryWrapper from '@pages/Beneficiary-block/BeneficiaryWrapper';
const BeneficiaryWrapper = lazy(() => import('@pages/Beneficiary-block/BeneficiaryWrapper'));
// import CommonAncFields from '@pages/Beneficiary-block/WomenComponent/ANC/Forms/CreateAndEdit/CommonAncFields';
const CommonAncFields = lazy(() => import('@pages/Beneficiary-block/WomenComponent/ANC/Forms/CreateAndEdit/CommonAncFields'));
// import CommonAncOverviewFields from '@pages/Beneficiary-block/WomenComponent/ANC/Forms/View/CommonAncOverviewFields';
const CommonAncOverviewFields = lazy(() => import('@pages/Beneficiary-block/WomenComponent/ANC/Forms/View/CommonAncOverviewFields'));
// import CommonDeliveryForms from '@pages/Beneficiary-block/WomenComponent/DeliveryOutcome/CommonDeliveryForms';
const CommonDeliveryForms = lazy(() => import('@pages/Beneficiary-block/WomenComponent/DeliveryOutcome/CommonDeliveryForms'));
// import DeathForm from '@pages/Beneficiary-block/WomenComponent/Death/DeathForm/DeathForm';
const DeathForm = lazy(() => import('@pages/Beneficiary-block/WomenComponent/Death/DeathForm/DeathForm'));
// import PregnancyServices from '@pages/Beneficiary-block/WomenComponent/PregnancyTracking/PregnancyServices';
const PregnancyServices = lazy(() => import('@pages/Beneficiary-block/WomenComponent/PregnancyTracking/PregnancyServices'));
// import AddServices from '@pages/Beneficiary-block/WomenComponent/FamilyPlanning/AddServices';
const AddServices = lazy(() => import('@pages/Beneficiary-block/WomenComponent/FamilyPlanning/AddServices'));
// import CommonFamilyPlanningView from '@pages/Beneficiary-block/WomenComponent/FamilyPlanning/view';
const CommonFamilyPlanningView = lazy(() => import('@pages/Beneficiary-block/WomenComponent/FamilyPlanning/view'));
// import CommonFormFamilyPlanning from '@pages/Beneficiary-block/WomenComponent/FamilyPlanning/view/Form';
const CommonFormFamilyPlanning = lazy(() => import('@pages/Beneficiary-block/WomenComponent/FamilyPlanning/view/Form'));
// import FacilityReferral from '@pages/Beneficiary-block/WomenComponent/FacilityReferral';
const FacilityReferral = lazy(() => import('@pages/Beneficiary-block/WomenComponent/FacilityReferral'));
// import ReferralView from '@pages/Beneficiary-block/WomenComponent/FacilityReferral/ReferralView';
const ReferralView = lazy(() => import('@pages/Beneficiary-block/WomenComponent/FacilityReferral/ReferralView'));
// import FacilityWrapper from '@pages/Beneficiary-block/WomenComponent/FacilityReferral/Grid/FacilityWrapper';
const FacilityWrapper = lazy(() => import('@pages/Beneficiary-block/WomenComponent/FacilityReferral/Grid/FacilityWrapper'));
import { executionRoleCode } from '@constants/vhndExecutionConstant';
import { MODULE_CODES, PAGE_CODES } from '@constants/moduleAndPageCodes';
import NewBornForm from '@pages/Beneficiary-block/WomenComponent/Child/ChildServices/NewBorn/NewBornForm/NewBornForm';
import ChildServiceView from '@pages/Beneficiary-block/WomenComponent/Child/ChildServiceView';
import AbortionForm from '@pages/Beneficiary-block/WomenComponent/Abortion/AbortionForm';
import { routes_page_constant } from './constants';
import SickChildCare from '@pages/Beneficiary-block/WomenComponent/Child/ChildServices/SickChildCare';
const NHVCPReport = lazy(() => import('@pages/Report/NHVCPReport'));
const PwHIVReferralDeliveryReport = lazy(() => import('@pages/Report/PwHIVReferralDeliveryReport'));

const userManagement = {
  page: 'User Management', tabs: [
    { "module_name": "All Users", "module_code": "UserMgmt" },
    { "module_name": "Roles", "module_code": "UserMgmt_Roles" },
    { "module_name": "Analytics", "module_code": "UserMgmt_ANTS" }
  ]
};

const GeoNonGeo = {
  page: 'Geographical Entities', tabs: [{ "module_name": "Zone/Division/Circle", "module_code": "GeoNG_ZDC" },
  { "module_name": "VHND/UHND Outreach", "module_code": "GeoNG_VHNDUHND" },
  { "module_name": "Health Block /Sub Division", "module_code": "GeoNG_HBSD" }]
};


const healthFacility = {
  page: 'Health Facility',
  tabs: ['Health Facility Maintenance'],
};

const referralModule = {
  page: 'Referral Module',
  tabs: ["Referral List", "Blood Bank Availability Search"
  ],
};

const hrpRuleMaster = {
  page: 'HRP Parameters', tabs: [
    { "module_name": "Hrp Conditions", "module_code": "Hrp Conditions" },
    { "module_name": "Hrp Audit", "module_code": "Hrp Audit" },]
};

const ancRuleMaster = {
  page: 'ANC Rule Master', 
  tabs: ['ANC Conditions']
};

const userMgmtRuleMaster = {
  page: 'User management Rule Master', 
  tabs: ['User Mgmt Conditions']
};

const beneficiary = {
  page: 'Beneficiaries',
  tabs: ['Beneficiaries'],
};

const references = {
  page: 'References',
  tabs: ['References and Links'],
};

const notifications = {
  page: 'Notifications',
  tabs: [],
};

const integrations = {
  page: 'Integrations',
  tabs: [],
};

const reportProps = {
  page: 'Reports Module',
  tabs: ['Parameter Selection', 'Migration Report']
}

const reportExportProps = {
  page: 'Reports',
  tabs: ['RCH Implementation']
}

const vhndUhndExecution = {
  page: 'VHND/UHND Execution', tabs: [
    { "module_name": "VHND/UHND Execution", "module_code": executionRoleCode.module_code }
  ]
};

const work_plan = {
  page: 'Work Plan', tabs: [
    { "module_name": "Work Plan", "module_code": "work_plan" }
  ]
}
  const approval_flow = {
    page: 'Approvals', tabs: [
      { "module_name": "Approvals", "module_code": "Approvals" }
    ]
};


const App: React.FC = () => {

  const LoginRedirect = () => {
    return Auth.loggedIn().headers ? <Navigate to="/" /> : <Outlet />
  }
  const root = config.root ? config.root : '';
  const userPermissions = localStorage.getItem('userPermissions') ? JSON.parse(decodeWithKeyAndShift(localStorage.getItem('userPermissions'))) : JSON.stringify({});
  const Protected = () => {
    return Auth.loggedIn().headers ? <Outlet /> : <Navigate to="/login" />;
  };
  const [isOverlayPass, setisOverlayPass] = useState(config.showOverlay ? false : true);
  const handleOverlayLogin = (status: any) => {
    setisOverlayPass(status);  // Update state when user is authenticated
  };
  return (
    <Provider store={store}>
      <AuthErrorModal />
      {config.showOverlay && !isOverlayPass && <InitialOverlay onOverlayLogin={handleOverlayLogin} />}
      {isOverlayPass && (<PermissionsProvider userPermissions={userPermissions ? userPermissions : []}>
        <Router basename={root}>
          <GlobalRenderController>          
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
              <Route path="/" element={<WebsiteProvider> <WebSitePageNew /> </WebsiteProvider>} />
              <Route path="/home" element={<HomePage />} />

              <Route element={<LoginRedirect />}>
                <Route path="/login" element={<AuthWrapperComponent authPage={'login'} />} />
                <Route path="/commonlogin" element={<Commonlogin />} />
              </Route>
              {/* <Route path="/dashboard" element={<DashboardPOC />} /> */}
              <Route path="/logout" element={<LogoutPage />} />
              {/* <Route path="/register" element={<RegistrationForm />} /> */}
              {/* <Route path="/localization" element={<LocalizationApp />} /> */}
              {/* <Route path="/user" element={<UserList />} /> */}
              {/* <Route path="/platform" element={<PlatformComponent />} /> */}
              {/* <Route path="/graphqlpoc" element={<Graphqlpoc />} /> */}
              {/* <Route path="/mappoc1" element={<EmbeddedMapsPOC />} /> */}
              <Route path="/user-self-registration" element={<UserSelfRegistration />} />
              <Route path="/beneficiary-self-registration" element={<BeneficiarySelfRegistartion />} />
          </Routes>
          </Suspense>
          <InactivityDetector timeout={config.idealTimeOutPeriodInMs}> {/* Set timeout to 10 minutes */}
          <Suspense fallback={<div>Loading...</div>}> <Routes>
                <Route element={<Protected />}>
                  <Route
                    path="/user-management"
                    element={<PagePermissionRedirect moduleCode="UserMgmt" pageCode="UserMgmt_LstPg" ><AppWrapperComponent {...userManagement} tabsPermision={true} /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/user-management/view/:id"
                    element={<PagePermissionRedirect moduleCode="UserMgmt" pageCode="UserMgmt_OVPg" ><AppWrapperViewComponent page={'user'} flow={'view'} /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/user-management/edit/:id"
                    element={<PagePermissionRedirect moduleCode="UserMgmt" pageCode="UserMgmt_EdPg" ><AppWrapperViewComponent page={'user'} flow={'edit'} /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/user-management/create"
                    element={<PagePermissionRedirect moduleCode="UserMgmt" pageCode="UserMgmt_CrPg" ><AppWrapperViewComponent page={'user'} flow={'create'} /></PagePermissionRedirect>}
                  />
                  <Route path="/user-management/role" element={<PagePermissionRedirect moduleCode="UserMgmt_Roles" pageCode="Roles_LstPg" ><AppWrapperComponent {...userManagement} tabsPermision={true} showGeoTab="role" /></PagePermissionRedirect>} />
                  <Route
                    path="/user-management/create-new-role"
                    element={<PagePermissionRedirect moduleCode="UserMgmt_Roles" pageCode="Roles_CrPg" ><AppWrapperViewComponent page={'user_role'} flow={'createNewRole'} /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/user-management/role/view/:id"
                    element={<PagePermissionRedirect moduleCode="UserMgmt_Roles" pageCode="Roles_OVPg" ><AppWrapperViewComponent page={'user_role'} flow={'viewRole'} /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/user-management/role/edit/:id"
                    element={<PagePermissionRedirect moduleCode="UserMgmt_Roles" pageCode="Roles_EdPg" ><AppWrapperViewComponent page={'user_role'} flow={'editRole'} /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/user-management/analytics"
                    element={<PagePermissionRedirect moduleCode="UserMgmt_ANTS" pageCode="ANTS_LstPg" ><AppWrapperComponent {...userManagement} tabsPermision={true} showGeoTab="analytics" /></PagePermissionRedirect>}
                  />

                  <Route
                    path="/zone"
                    element={<PagePermissionRedirect moduleCode="GeoNG_ZDC" pageCode="GeoNG_ZDC_LstPg" ><AppWrapperComponent {...GeoNonGeo} tabsPermision={true} showGeoTab="zone" /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/zone/create"
                    element={<PagePermissionRedirect moduleCode="GeoNG_ZDC" pageCode="GeoNG_ZDC_CrPg" ><AppWrapperViewComponent page={'zone_details'} flow={'create'} /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/zone/view/:id"
                    element={<PagePermissionRedirect moduleCode="GeoNG_ZDC" pageCode="GeoNG_ZDC_OVPg" ><AppWrapperViewComponent page={'zone_details'} flow={'view'} /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/zone/edit/:id"
                    element={<PagePermissionRedirect moduleCode="GeoNG_ZDC" pageCode="GeoNG_ZDC_EdPg" ><AppWrapperViewComponent page={'zone_details'} flow={'edit'} /></PagePermissionRedirect>}
                  />

                  <Route
                    path="/healthblock"
                    element={<PagePermissionRedirect moduleCode="GeoNG_HBSD" pageCode="GeoNG_HBSD_LstPg" ><AppWrapperComponent {...GeoNonGeo} tabsPermision={true} showGeoTab="healthblock" /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/healthblock/create"
                    element={<PagePermissionRedirect moduleCode="GeoNG_HBSD" pageCode="GeoNG_HBSD_CrPg" ><AppWrapperViewComponent page={'health_block'} flow={'create'} /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/healthblock/view/:id"
                    element={<PagePermissionRedirect moduleCode="GeoNG_HBSD" pageCode="GeoNG_HBSD_OVPg" ><AppWrapperViewComponent page={'health_block'} flow={'view'} /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/healthblock/edit/:id"
                    element={<PagePermissionRedirect moduleCode="GeoNG_HBSD" pageCode="GeoNG_HBSD_EdPg" ><AppWrapperViewComponent page={'health_block'} flow={'edit'} /></PagePermissionRedirect>}
                  />

                  <Route
                    path="/VHND"
                    element={<PagePermissionRedirect moduleCode="GeoNG_VHNDUHND" pageCode="GeoNG_VHNDUHND_LstPg" ><AppWrapperComponent {...GeoNonGeo} tabsPermision={true} showGeoTab="VHND" /></PagePermissionRedirect>}
                  />

                  <Route
                    path="/VHND/create"
                    element={<PagePermissionRedirect moduleCode="GeoNG_VHNDUHND" pageCode="GeoNG_VHNDUHND_CrPg" ><AppWrapperViewComponent page={'vhnd_uhnd_block'} flow={'create'} /></PagePermissionRedirect>}
                  />

                  <Route
                    path="/VHND/view/:id"
                    element={<PagePermissionRedirect moduleCode="GeoNG_VHNDUHND" pageCode="GeoNG_VHNDUHND_OVPg" ><AppWrapperViewComponent page={'vhnd_uhnd_block'} flow={'view'} /></PagePermissionRedirect>}
                  />

                  <Route
                    path="/VHND/edit/:id"
                    element={<PagePermissionRedirect moduleCode="GeoNG_VHNDUHND" pageCode="GeoNG_VHNDUHND_EdPg" ><AppWrapperViewComponent page={'vhnd_uhnd_block'} flow={'edit'} /></PagePermissionRedirect>}
                  />

                  <Route
                    path="/VHND/create-duplicate-session/:id"
                    element={<PagePermissionRedirect moduleCode="GeoNG_VHNDUHND" pageCode="GeoNG_VHNDUHND_EdPg" ><AppWrapperViewComponent page={'vhnd_uhnd_block'} flow={'duplicate'} /></PagePermissionRedirect>}
                  />

                  <Route
                    path="/health-facility"
                    element={<PagePermissionRedirect moduleCode="FcltyMgmt" pageCode="FcltyMgmt_LstPg" ><AppWrapperComponent {...healthFacility} /></PagePermissionRedirect>}
                  />

                  <Route
                    path="/health-facility/create"
                    element={<PagePermissionRedirect moduleCode="FcltyMgmt" pageCode="FcltyMgmt_CrPg" ><AppWrapperViewComponent page={'health_facility'} flow={'create'} /></PagePermissionRedirect>}
                  />

                  <Route
                    path="/health-facility/view/:id"
                    element={<PagePermissionRedirect moduleCode="FcltyMgmt" pageCode="FcltyMgmt_OVPg" ><AppWrapperViewComponent page={'health_facility'} flow={'view'} /></PagePermissionRedirect>}
                  />

                  <Route
                    path="/health-facility/update/:id"
                    element={<PagePermissionRedirect moduleCode="FcltyMgmt" pageCode="FcltyMgmt_EdPg" ><AppWrapperViewComponent page={'health_facility'} flow={'update'} /></PagePermissionRedirect>}
                  />

                  <Route
                    path="/health-facility/upgrade/:id"
                    element={<PagePermissionRedirect moduleCode="FcltyMgmt" pageCode="FcltyMgmt_ApprvPg" ><AppWrapperViewComponent page={'health_facility'} flow={'upgrade'} /></PagePermissionRedirect>}
                  />

                  <Route
                    path="/health-facility/edit/:id"
                    element={<PagePermissionRedirect moduleCode="FcltyMgmt" pageCode="FcltyMgmt_EdPg" ><AppWrapperViewComponent page={'health_facility'} flow={'edit'} /></PagePermissionRedirect>}
                  />

                  <Route path="/beneficiaries" element={<PagePermissionRedirect moduleCode="Benf" pageCode="Benf_LstPg" ><BeneficiaryWrapper {...beneficiary} /></PagePermissionRedirect>} />
                  <Route path="/referralModule" element={<PagePermissionRedirect moduleCode="ReferralModule" pageCode="ReferralModule_LstPg" ><FacilityWrapper {...referralModule} showGeoTab="referralModule" /></PagePermissionRedirect>} />
                  <Route
                    path="/beneficiaries/create"
                    element={<PagePermissionRedirect moduleCode="Benf" pageCode="Benf_CrPg" ><AppWrapperViewComponent page={'beneficiary'} flow={'create'} /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/beneficiaries/view/:id"
                    element={<PagePermissionRedirect moduleCode="Benf" pageCode="Benf_OVPg" ><AppWrapperViewComponent page={'beneficiary'} flow={'view'} /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/beneficiaries/view/temp/:id"
                    element={<PagePermissionRedirect moduleCode="Benf" pageCode="Benf_OVPg" ><AppWrapperViewComponent page={'beneficiary'} flow={'view-temp'} /></PagePermissionRedirect>}
                  />

                  <Route
                    path="/beneficiaries/edit/:id"
                    element={<PagePermissionRedirect moduleCode="Benf" pageCode="Benf_EdPg" ><AppWrapperViewComponent page={'beneficiary'} flow={'edit'} /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/beneficiaries/edit/temp/:id"
                    element={<PagePermissionRedirect moduleCode="Benf" pageCode="Benf_EdPg" ><AppWrapperViewComponent page={'beneficiary'} flow={'edit-temp'} /></PagePermissionRedirect>}
                  />

                  <Route path="/beneficiaries/create-new-child"
                    element={<PagePermissionRedirect moduleCode="Benf_ChildBenf" pageCode="ChildBenf_CrPg" ><AppWrapperViewComponent page={'beneficiary'} flow={'createNewChild'} /> </PagePermissionRedirect>} />

                  <Route
                    path="/beneficiaries/temp"
                    element={<PagePermissionRedirect moduleCode="Benf" pageCode="Benf_LstPg" ><AppWrapperViewComponent page={'temporaryRegistration'} flow={'temp'} /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/beneficiaries/service"
                    element={<PagePermissionRedirect moduleCode="Benf_Service" pageCode="Service_CrPg" ><AppWrapperViewComponent page={'beneficiary'} flow={'ancService'} /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/beneficiaries/pnc/service"
                    element={<PagePermissionRedirect moduleCode="Benf_Service" pageCode="Service_CrPg" ><AppWrapperViewComponent page={'beneficiary'} flow={'pncService'} /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/beneficiaries/pnc/overview/:service"
                    element={<PagePermissionRedirect moduleCode="Benf_Service" pageCode="Service_OVPg" ><CommonAncOverviewFields /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/beneficiaries/pnc/edit/:service"
                    element={<PagePermissionRedirect moduleCode="Benf_Service" pageCode="Service_EdPg" ><CommonAncFields /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/beneficiaries/anc-service/:service"
                    element={<PagePermissionRedirect moduleCode="Benf_Service" pageCode="Service_CrPg" ><CommonAncFields /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/beneficiaries/child/:service"
                    element={<CommonAncFields />}
                  />
                  <Route
                    path="/beneficiaries/child/edit/:service"
                    element={<CommonAncFields />}
                  />
                  <Route
                    path="/beneficiaries/abortion/view/:service"
                    element={<CommonAncOverviewFields />}
                  />
                  <Route
                    path="/beneficiaries/pnc/:service"
                    element={<PagePermissionRedirect moduleCode="Benf_Service" pageCode="Service_CrPg" ><CommonAncFields /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/beneficiaries/anc-service/edit/:service"
                    element={<PagePermissionRedirect moduleCode="Benf_Service" pageCode="Service_EdPg" ><CommonAncFields /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/beneficiaries/death/:service"
                    element={<DeathForm />}
                  />
                     <Route
                    path="/beneficiaries/abortion/:service"
                    element={<AbortionForm />}
                  />

                  <Route
                    path="/beneficiaries/service/:service"
                    element={<NewBornForm />}
                  />
                  <Route
                    path="/beneficiaries/sick-child-care"
                    element={<PagePermissionRedirect  moduleCode="Benf_Service" pageCode="Service_CrPg" ><AppWrapperViewComponent page={'beneficiary'} flow={'createSickChildCare'} /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/beneficiaries/hbyc/service"
                    element={<PagePermissionRedirect  moduleCode="Benf_Service" pageCode="Service_CrPg" ><AppWrapperViewComponent page={'beneficiary'} flow={'createHbyc'} /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/beneficiaries/hbyc/service"
                    element={<PagePermissionRedirect  moduleCode="Benf_Service" pageCode="Service_CrPg" ><AppWrapperViewComponent page={'beneficiary'} flow={'createHbyc'} /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/beneficiaries/child/service-facility-details"
                    element={<PagePermissionRedirect  moduleCode="Benf_Service" pageCode="Service_CrPg" ><AppWrapperViewComponent page={'beneficiary'} flow={'childService'} /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/beneficiaries/abortion/service-facility-details"
                    element={<PagePermissionRedirect  moduleCode="Benf_Service" pageCode="Service_CrPg" ><AppWrapperViewComponent page={'beneficiary'} flow={'abortion'} /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/beneficiaries/child/view/:service"
                    element={<PagePermissionRedirect  moduleCode="Benf_Service" pageCode="Service_OVPg" ><ChildServiceView /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/beneficiaries/hrp"
                    element={<PagePermissionRedirect moduleCode="Benf" pageCode="Benf_LstPg" ><AppWrapperViewComponent page={'beneficiary'} flow={'hrp'} /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/beneficiaries/selecthrp"
                    element={<PagePermissionRedirect moduleCode="Benf" pageCode="Benf_LstPg" ><AppWrapperViewComponent page={'beneficiary'} flow={'selecthrp'} /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/beneficiaries/anc-service/overview/:service"
                    element={<PagePermissionRedirect moduleCode="Benf_Service" pageCode="Service_OVPg" ><CommonAncOverviewFields /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/beneficiaries/family-planning-details"
                    element={<AddServices />}
                  />
                  <Route
                    path="/beneficiaries/family-planning/overview"
                    element={<CommonFamilyPlanningView />}
                  />
                  <Route
                    path="/beneficiaries/family-planning/:formType"
                    element={<CommonFormFamilyPlanning />}
                  />
                  <Route path="/beneficiaries/facility-referral" element={<PagePermissionRedirect moduleCode={MODULE_CODES.BENEFICIARY_SERVICE} pageCode={PAGE_CODES.SERVICE_CREATE} ><FacilityReferral /></PagePermissionRedirect>} />
                  <Route path="/beneficiaries/view/facility-referral" element={<PagePermissionRedirect moduleCode={MODULE_CODES.BENEFICIARY_SERVICE} pageCode={PAGE_CODES.SERVICE_OVERVIEW} ><ReferralView /></PagePermissionRedirect>} />

                  <Route path='/service' element={<PregnancyServices />} />
                  <Route
                    path="/beneficiaries/service/edit/:service"
                    element={<PagePermissionRedirect moduleCode="Benf_Service" pageCode="Service_EdPg" ><CommonAncFields /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/beneficiaries/service/overview/:service"
                    element={<PagePermissionRedirect moduleCode="Benf_Service" pageCode="Service_OVPg" ><CommonAncOverviewFields /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/beneficiaries/:delivery"
                    element={<CommonDeliveryForms />}
                  />
                  <Route
                    path="/references"
                    element={<PagePermissionRedirect moduleCode="References" pageCode="References_OVPg" ><AppWrapperComponent {...references} /></PagePermissionRedirect>}
                  />

                  <Route
                    path="/notifications"
                    element={<PagePermissionRedirect moduleCode="Notifications" pageCode="Notifications_LstPg" ><AppWrapperComponent {...notifications} /></PagePermissionRedirect>}
                  />

                  <Route
                    path="/integrations"
                    element={<PagePermissionRedirect moduleCode="Integrations" pageCode="Integrations_LstPg" ><AppWrapperComponent {...integrations} /></PagePermissionRedirect>}
                  />
                  <Route path='/report' element={<Report {...reportProps} />} />
                  <Route path="/reportpage" element={<ReportPage2 page={''} flow={''} />} />
                  <Route path="reportexp/:reportName" element={<ReportExport {...reportExportProps} />} />
                  <Route path="/landing-page" element={<LandingPageWrapperComponent page={routes_page_constant.dashBoard} tabs={[]} />} />
                  <Route path="/benef-landing-page" element={<PagePermissionRedirect moduleCode="BenefLandingPage" pageCode="Benef_LandingPg" ><BenefLandingPage page={'benefLandingPage'} flow={'BeneficiaryLandingPage'} /></PagePermissionRedirect>} />
                  <Route path="/benef-mcp-card" element={<PagePermissionRedirect moduleCode="BenefLandingPage" pageCode="Benef_LandingPg" ><BenefLandingPage page={'benefLandingPage'} flow={'BeneficiaryMCPCard'} /></PagePermissionRedirect>} />
                  <Route path="/beneficiaries/temp" element={<PagePermissionRedirect moduleCode="Benf" pageCode="Benf_LstPg" ><AppWrapperViewComponent page={'temporaryRegistration'} flow={'temp'} /></PagePermissionRedirect>} />
                  <Route path="/health-facility-master-report" element={<HealthFacilityMasterReport page={''} flow={''} />} />
                  <Route path="/health-provider-master-report" element={<HealthProviderMasterReport page={''} flow={''} />} />
                  <Route path="/pregnant-women-line-listing-report" element={<PagePermissionRedirect moduleCode={'Report'} pageCode={"Report_LstPg"} ><PwLineListingReport page={''} flow={''} /></PagePermissionRedirect>} />
                  <Route path="/pregnant-women-registration-report" element={<PagePermissionRedirect moduleCode={'Report'} pageCode={"Report_LstPg"} ><PregnantWomenReport page={''} flow={''} /></PagePermissionRedirect>} />
                  <Route path="/tests-done-report" element={<PagePermissionRedirect moduleCode={'Report'} pageCode={"Report_LstPg"} ><TestsDoneReport page={''} flow={''} /></PagePermissionRedirect>} />
                  <Route path="/vhnd-uhnd-execution" element={<PagePermissionRedirect moduleCode={executionRoleCode.module_code} pageCode={executionRoleCode.pageCode.VHNDUHND_Execution_LstPg} ><LandingPageWrapperComponent {...vhndUhndExecution} tabsPermision={true} /></PagePermissionRedirect>} />
                  <Route path="/workplan" element={<PagePermissionRedirect moduleCode="work_plan" pageCode="work_plan_LstPg" ><LandingPageWrapperComponent {...work_plan} tabsPermision={true} /></PagePermissionRedirect>} />
                  <Route path="/hrp-parameters" element={<PagePermissionRedirect moduleCode={MODULE_CODES.SERVICE_MASTER} pageCode={PAGE_CODES.SERVICE_MASTER_OVERVIEW} ><ServiceMasterWrapperComponent {...hrpRuleMaster} tabsPermision={true} /></PagePermissionRedirect>} />
                  <Route path="/hrp-parameters/audit" element={<PagePermissionRedirect moduleCode={MODULE_CODES.SERVICE_MASTER} pageCode={PAGE_CODES.SERVICE_MASTER_OVERVIEW} ><ServiceMasterWrapperComponent {...hrpRuleMaster} tabsPermision={true} showTab="Hrp Audit" /></PagePermissionRedirect>} />
                  <Route path="/anc-rule-master" element={<ServiceMasterWrapperComponent {...ancRuleMaster} tabsPermision={false} />} />
                  <Route path="/user-mgmt-rule-master" element={<ServiceMasterWrapperComponent {...userMgmtRuleMaster} tabsPermision={false} />} />
                  <Route path="/pregnancy-care-services-report" element={<PagePermissionRedirect moduleCode={'Report'} pageCode={"Report_LstPg"} ><PregnancyCareServicesReport page={''} flow={''} /></PagePermissionRedirect>} />
                  <Route path="/delivery-report" element={<PagePermissionRedirect moduleCode={'Report'} pageCode={"Report_LstPg"} ><DeliveryReport page={''} flow={''} /></PagePermissionRedirect>} />
                  <Route path="/anc-report" element={<PagePermissionRedirect moduleCode={'Report'} pageCode={"Report_LstPg"} ><ANCReport page={''} flow={''} /></PagePermissionRedirect>} />
                  <Route path="/hiv-pw-syphilis-report" element={<PagePermissionRedirect moduleCode={'Report'} pageCode={"Report_LstPg"} ><HIVPWsSyphilisReport page={''} flow={''} /></PagePermissionRedirect>} />
                  <Route path="/nhvcp-report" element={<PagePermissionRedirect moduleCode={'Report'} pageCode={"Report_LstPg"} ><NHVCPReport page={''} flow={''} /></PagePermissionRedirect>} />
                  <Route path="/pw-hiv-referral-delivery-report" element={<PagePermissionRedirect moduleCode={'Report'} pageCode={"Report_LstPg"} ><PwHIVReferralDeliveryReport page={''} flow={''} /></PagePermissionRedirect>} />
                  <Route
                    path="/approvals-flow"
                    element={<PagePermissionRedirect moduleCode="Approvals" pageCode="Approvals_LstPg" ><LandingPageWrapperComponent {...approval_flow} tabsPermision={true} /></PagePermissionRedirect>}
                  />
                  <Route
                    path="/approvals/:id"
                    element={<PagePermissionRedirect moduleCode="Approvals" pageCode="Approvals_OVPg" ><AppWrapperViewComponent page={'approval_overView'} flow={'overView'} /></PagePermissionRedirect>}
                  />
                </Route>
            </Routes> </Suspense>
          </InactivityDetector>
          </GlobalRenderController>
        </Router>
      </PermissionsProvider>)}

    </Provider>
  );
};
export default App;